import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiBook, FiClock, FiEye, FiSearch } from 'react-icons/fi';
import './Library.css';

const Library = () => {
  const [collections, setCollections] = useState([]);
  const [featuredBooks, setFeaturedBooks] = useState([]);
  const [stats, setStats] = useState({ total_books: 0, total_reads: 0, avg_reading_time: 0 });
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    loadLibrary();
  }, []);

  const loadLibrary = async () => {
    try {
      const res = await fetch('http://localhost:5000/api/library');
      const data = await res.json();
      setCollections(data.collections || []);
      setFeaturedBooks(data.featured || []);
      setStats(data.stats || { total_books: 0, total_reads: 0, avg_reading_time: 0 });
    } catch (error) {
      console.error('Error loading library:', error);
      setCollections([]);
      setFeaturedBooks([]);
      setStats({ total_books: 0, total_reads: 0, avg_reading_time: 0 });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="library-loading">
        <div className="loading-spinner"></div>
        <p>Cargando biblioteca...</p>
      </div>
    );
  }

  return (
    <div className="library-page">
      {/* Hero Header estilo biblioteca */}
      <header className="library-hero">
        <div className="library-hero-content">
          <div className="library-icon">📚</div>
          <h1>Biblioteca GRAPHYRA</h1>
          <p>Tu repositorio de conocimiento curado. Los mejores artículos organizados para ti.</p>
          
          <div className="library-search">
            <FiSearch className="search-icon" />
            <input 
              type="text"
              placeholder="Buscar en la biblioteca..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        
        {/* Decoración de estantes */}
        <div className="library-shelves">
          <div className="shelf"></div>
          <div className="shelf"></div>
          <div className="shelf"></div>
        </div>
      </header>

      {/* Estadísticas */}
      <section className="library-stats">
        <div className="stat-item">
          <FiBook className="stat-icon" />
          <div className="stat-info">
            <span className="stat-number">{stats.total_books || 0}</span>
            <span className="stat-label">Artículos</span>
          </div>
        </div>
        <div className="stat-item">
          <span className="stat-icon">📂</span>
          <div className="stat-info">
            <span className="stat-number">{collections.length}</span>
            <span className="stat-label">Colecciones</span>
          </div>
        </div>
        <div className="stat-item">
          <FiEye className="stat-icon" />
          <div className="stat-info">
            <span className="stat-number">{stats.total_reads || 0}</span>
            <span className="stat-label">Lecturas</span>
          </div>
        </div>
        <div className="stat-item">
          <FiClock className="stat-icon" />
          <div className="stat-info">
            <span className="stat-number">~{Math.round(stats.avg_reading_time || 0)} min</span>
            <span className="stat-label">Lectura promedio</span>
          </div>
        </div>
      </section>

      {/* Colecciones - Estanterías */}
      <section className="library-collections">
        <h2>📖 Colecciones</h2>
        <p className="section-desc">Explora nuestras secciones temáticas</p>
        
        <div className="collections-grid">
          {collections.map(collection => (
            <Link 
              key={collection.id}
              to={`/library/${collection.slug}`}
              className="collection-card"
              style={{ '--collection-color': collection.color }}
            >
              <div className="collection-spine"></div>
              <div className="collection-content">
                <span className="collection-icon">{collection.icon}</span>
                <h3>{collection.name}</h3>
                <p>{collection.description}</p>
                <span className="collection-count">{collection.book_count || '0'} artículos</span>
              </div>
              <div className="collection-decoration">
                <div className="book-stack">
                  <div className="mini-book" style={{ background: collection.color }}></div>
                  <div className="mini-book" style={{ background: collection.color, opacity: 0.7 }}></div>
                  <div className="mini-book" style={{ background: collection.color, opacity: 0.5 }}></div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Libros destacados */}
      <section className="library-featured">
        <h2>⭐ Lecturas Destacadas</h2>
        <p className="section-desc">Los artículos más valorados por nuestra comunidad</p>
        
        <div className="featured-books">
          {featuredBooks.length > 0 ? (
            featuredBooks.map(book => (
              <Link key={book.id} to={`/article/${book.slug}`} className="book-card">
                <div className="book-cover">
                  <img src={book.cover_image} alt={book.title} />
                </div>
                <div className="book-info">
                  <h4>{book.title}</h4>
                  <p className="book-author">{book.author_name}</p>
                  <span className="book-reading-time">
                    <FiClock /> {book.reading_time || 5} min de lectura
                  </span>
                </div>
              </Link>
            ))
          ) : (
            <div className="no-featured">
              <p>Próximamente: Los mejores artículos aparecerán aquí</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA para contribuir */}
      <section className="library-cta">
        <div className="cta-content">
          <h3>¿Tienes un artículo destacado?</h3>
          <p>Los mejores artículos de la comunidad pueden ser parte de nuestra biblioteca</p>
          <Link to="/create" className="btn btn-primary">Publicar Artículo</Link>
        </div>
      </section>
    </div>
  );
};

export default Library;
